/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Week_Start_DescInputs */



/**
* | output |
* | --- |
* | "Which day appears as the first column in the week view." |
*
* @param {Settings_Week_Start_DescInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const settings_week_start_desc = /** @type {((inputs?: Settings_Week_Start_DescInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Week_Start_DescInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Welke dag als eerste kolom verschijnt in de weekweergave.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Quel jour apparaît comme première colonne dans la vue semaine.")
	return /** @type {LocalizedString} */ ("Which day appears as the first column in the week view.")
});